import React, { useState } from "react";
import {
  Tooltip,
  TableContainer,
  TableCell,
  TableRow,
  Table,
  TableHead,
  Checkbox,
  TableBody,
  TablePagination,
  Avatar,
  IconButton,
  MenuItem,
  Menu,
  ListItemIcon,
  Modal,
  Box,
  FormControl,
  TextField,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import MessageSnackbar from "../_layout/elements/snackbar";
import pdffile from "../assets/images/pdf-file.svg";
import EditNoteOutlinedIcon from "@mui/icons-material/EditNoteOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import CircularWithValueLabel from "./filestatus";
import TableLoader from "./loader/table-loader";
import host from "../host";
import { useDispatch } from "react-redux";
import { changeAuth } from "../actions/loginAction";
import docicon from "../assets/images/docx.jpg";
import excelicon from "../assets/images/excel.jpg";
import websiteIcon from "../assets/images/type_website.png";
function PdfList(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  //this below function for delete member   popup start//
  const [opendelete, setOpendelete] = React.useState(false);
  const activedelet = () => setOpendelete(true);
  const handleClosedelete = () => setOpendelete(false);
  //this below function for delete member   popup end//

  //snackbar starts
  const [snackbar, setSnackbar] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const onClose = () => {
    setSnackbar(false);
  };
  //snackbar ends
  //this below function for open action box table  start//
  const [isVisible, setIsVisible] = useState(false);
  //this below function for open action box table  end//
  const handleCheckboxChange = (pdfData) => {
    const selectedIndex = props.selectedPDFs.indexOf(pdfData);
    let newSelectedPDFs = [...props.selectedPDFs];

    if (selectedIndex === -1) {
      newSelectedPDFs.push(pdfData);
    } else {
      newSelectedPDFs.splice(selectedIndex, 1);
    }

    props.setSelectedPDFs(newSelectedPDFs);
  };

  //this below function for table  pagination start//
  const handleChangePage = (event, newPage) => {
    props.setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    props.setLimit(parseInt(event.target.value, 10));
    props.setPage(0);
  };
  //this below function for table  pagination start//
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openedPdfId, setOpenedPdfId] = useState(null);
  const open = Boolean(anchorEl);
  const handleClickaction = (event, pdfId) => {
    setAnchorEl(event.currentTarget);
    setOpenedPdfId(pdfId);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setOpenedPdfId(null);
  };

  //function for rename pdf//
  const [openeditfile, setOpeneditfile] = React.useState(false);
  const [renameFile, setRenameFile] = useState({ id: null, newName: "" });
  const activeeditfile = (fileId, currentName) => {
    setRenameFile({ id: fileId, newName: currentName });
    setOpeneditfile(true);
  };
  const handleCloseeditfile = () => {
    setOpeneditfile(false);
    setRenameFile({ id: null, newName: "" }); // Reset the rename state
  };
  const handleNewNameChange = (event) => {
    setRenameFile({ ...renameFile, newName: event.target.value });
  };
  //function for rename pdf end//

  const getFileStatusUpdate = (index, pdfDataId) => {
    fetch(host.chaturl + `/knowledge/file/${pdfDataId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        }
      })
      .then((data) => {
        if (data) {
          if (data._id === props.pdfListData[index].id) {
            props.setPdfListData((prevPdfListData) => {
              const newDataArray = [...prevPdfListData];
              newDataArray[index] = {
                ...newDataArray[index],
                status: data.status,
              };
              return newDataArray;
            });
          } else {
            console.log("Data id does not match at index ", index);
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  //rename functionality starts
  const handleRename = (knowledge_id) => {
    fetch(host.chaturl + `/knowledge/file/${knowledge_id}/rename?new_file_name=${renameFile.newName}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          dispatch(changeAuth(false, null));
          navigate("/logout");
        } else {
          setSeverity("error");
          setMessage("Something went wrong");
          setSnackbar(true);
        }
      })
      .then((data) => {
        if (data) {
          props.getKnowledge();
          setSeverity("success");
          setMessage("File name changed successfully");
          setSnackbar(true);
          handleCloseeditfile();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  //rename functionality ends

  //   function for donwload pdf start

  const handleDownload = async (fileUrl, fileName) => {
    try {
      // Fetch the PDF file
      const response = await fetch(fileUrl);
      const pdfBlob = await response.blob();

      // Create a URL for the Blob
      const url = URL.createObjectURL(pdfBlob);

      // Create an anchor element
      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.setAttribute("download", fileName ? fileName : "document.pdf");

      // Trigger download
      document.body.appendChild(anchor);
      anchor.click();

      // Clean up
      document.body.removeChild(anchor);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  //function for rename pdf ends

  function formatFileSize(size) {
    if (size === null || size === undefined) return "N/A";

    const KB = 1024;
    const MB = 1024 * KB;

    if (size < KB) {
      return `${size} B`;
    } else if (size < MB) {
      return `${(size / KB).toFixed(2)} KB`;
    } else {
      return `${(size / MB).toFixed(2)} MB`;
    }
  }

  const getFileStatus = (status) => {
    if (status) {
      if (status === "processing") {
        return "warning";
      } else if (status === "completed") {
        return "success";
      } else if (status === "failed") {
        return "danger";
      }
    } else {
      return "warning";
    }
  };
  const calculatePendingTime = (pdfData) => {
    if (pdfData.status === "processing") {
      const currentTime = new Date();
      const createdAtTime = new Date(pdfData.created_at);
      if (pdfData.processing_time === null) {
        return "processing";
      }
      const processingTime = pdfData.processing_time;
      const elapsedTimeInSeconds = Math.floor((currentTime - createdAtTime) / 1000);
      const pendingTimeInSeconds = processingTime - elapsedTimeInSeconds > 0 ? processingTime - elapsedTimeInSeconds : 0;

      return pendingTimeInSeconds;
    }
    return pdfData.status ? pdfData.status : "NA";
  };

  const getIcon = (fileName, doc_type) => {
    if (doc_type === "url") {
      return websiteIcon;
    } else if (doc_type === null) {
      if (!fileName) {
        return pdffile;
      }
      const fileParts = fileName?.split(".");
      const fileExtension = fileParts[fileParts?.length - 1];
      if (fileExtension === "pdf") {
        return pdffile;
      } else if (fileExtension === "docx") {
        return docicon;
      } else if (fileExtension === "xlsx") {
        return excelicon;
      } else {
        return pdffile;
      }
    } else {
      return pdffile;
    }
  };

  return (
    <>
      <MessageSnackbar open={snackbar} autoHideDuration={3000} onClose={onClose} severity={severity} message={message} />
      {!props.pdfListLoading ? (
        <div className="web-table pdflistingtable ">
          <TableContainer className=" ">
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell padding="checkbox">
                    <Checkbox
                      color="primary"
                      size="small"
                      checked={props.selectedPDFs.length > 0 && props.selectedPDFs.length === props.pdfListData.filter((pdfData) => pdfData.status === "completed").length}
                      onChange={() => {
                        if (props.selectedPDFs.length === props.pdfListData.filter((pdfData) => pdfData.status === "completed").length) {
                          props.setSelectedPDFs([]);
                        } else {
                          // Filter out the items with status !== "completed"
                          const completedPDFs = props.pdfListData.filter((pdfData) => pdfData.status === "completed");
                          props.setSelectedPDFs([...completedPDFs]);
                        }
                      }}
                      inputProps={{
                        "aria-label": "select all PDFs",
                      }}
                    />
                  </TableCell>
                  <TableCell>Name </TableCell>
                  <TableCell> File Size </TableCell>
                  <TableCell> Uploaded on</TableCell>
                  <TableCell> Uploaded By </TableCell>
                  <TableCell> Status</TableCell>
                  <TableCell> Action </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {props.pdfListData.map((pdfData, index) => (
                  <TableRow key={index} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                    <TableCell padding="checkbox">
                      <Checkbox
                        size="small"
                        color="primary"
                        checked={props.selectedPDFs.indexOf(pdfData) !== -1}
                        onChange={() => handleCheckboxChange(pdfData)}
                        inputProps={{
                          "aria-label": "select all desserts",
                        }}
                        disabled={pdfData.status !== "completed" ? true : false}
                      />
                    </TableCell>
                    <TableCell>
                      <div className="file-row">
                        <img src={getIcon(pdfData.file_name ? pdfData.file_name : null, pdfData.doc_type === "url" ? pdfData.doc_type : null)} height={30} alt="doc" />
                        <div className="filerowname"> {props?.isDatabase ? (pdfData.user.full_name ? pdfData.user.full_name : "NA") : (pdfData.file_name ? pdfData.file_name : pdfData.url ? pdfData.url : "NA")}</div>
                      </div>
                    </TableCell>
                    <TableCell>{props?.isDatabase ? "NA" : formatFileSize(pdfData.file_size)}</TableCell>
                    <TableCell>{new Date(pdfData.created_at).toDateString()}</TableCell>
                    <TableCell>
                      <div className="user-profile-head">
                        <Link to="#">
                          <div className="user-profile-pick">
                            <Avatar>{pdfData.user?.fullname?.split(/\s/).reduce((response, word) => (response += word.slice(0, 1)), "") ?? "NA"}</Avatar>
                          </div>
                          <div className="user-profile-content">
                            <span className="user-name">{pdfData.user !== null ? (pdfData.user.fullname ? pdfData.user.fullname : "NA") : "NA"}</span>
                            <span>{pdfData.user !== null ? (pdfData.user.email ? pdfData.user.email : "NA") : "NA"}</span>
                          </div>
                        </Link>
                      </div>
                    </TableCell>
                    <TableCell>
                      <div className="status_buttons">
                        {props?.isDatabase === false && pdfData.status === "processing" && <CircularWithValueLabel pdfData={pdfData} getFileStatusUpdate={getFileStatusUpdate} index={index} getKnowledge={props.getKnowledge} />}
                        {props?.isDatabase === false && pdfData.status !== "processing" && <span className={`badge bg-inverse-${getFileStatus(pdfData.status)}`}>{pdfData.status ? pdfData.status : "NA"}</span>}
                        {props?.isDatabase === true && <span className={`badge bg-inverse-success`}>completed</span>}
                        { props?.isDatabase === false &&  
                          <button type="btn " className="btn btn-primary" onClick={() => props.handleChatSpecificDoc(pdfData)} disabled={getFileStatus(pdfData.status) !== "success"}>
                            {" "}
                            Start Chat
                          </button>
                        }
                        {props?.isDatabase && <button type="btn " className="btn btn-primary" onClick={() => props.handleChatSpecificDoc(pdfData)}>
                            {" "}
                            Start Chat
                          </button>}
                      </div>
                    </TableCell>
                    <TableCell>
                      <Tooltip title="File settings">
                        <IconButton
                          onClick={(event) => {
                            handleClickaction(event, pdfData.id);
                          }}
                          size="small"
                          aria-controls={open ? "account-menu" : undefined}
                          aria-haspopup="true"
                          aria-expanded={open ? "true" : undefined}
                        >
                          <MoreHorizIcon />
                        </IconButton>
                      </Tooltip>
                      <Menu
                        anchorEl={anchorEl}
                        id="account-menu"
                        open={openedPdfId === pdfData.id}
                        onClose={handleClose}
                        onClick={handleClose}
                        PaperProps={{
                          elevation: 0,
                          sx: {
                            overflow: "visible",
                            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                            mt: 1.5,
                            "& .MuiAvatar-root": {
                              width: 32,
                              height: 32,
                              ml: -0.5,
                              mr: 1,
                            },
                            "&::before": {
                              content: '""',
                              display: "block",
                              position: "absolute",
                              top: 0,
                              right: 14,
                              width: 10,
                              height: 10,
                              bgcolor: "background.paper",
                              transform: "translateY(-50%) rotate(45deg)",
                              zIndex: 0,
                            },
                          },
                        }}
                        transformOrigin={{
                          horizontal: "right",
                          vertical: "top",
                        }}
                        anchorOrigin={{
                          horizontal: "right",
                          vertical: "bottom",
                        }}
                      >
                        <MenuItem onClick={() => pdfData.file_name && activeeditfile(pdfData.id, pdfData.file_name)}>
                          <ListItemIcon>
                            <EditNoteOutlinedIcon fontSize="small" />
                          </ListItemIcon>
                          Rename File
                        </MenuItem>
                        <MenuItem onClick={() => handleDownload(pdfData.file_path, pdfData.file_name)}>
                          <ListItemIcon>
                            <FileDownloadOutlinedIcon fontSize="small" />
                          </ListItemIcon>
                          Download File
                        </MenuItem>
                        <MenuItem onClick={activedelet}>
                          <ListItemIcon>
                            <DeleteOutlineOutlinedIcon fontSize="small" />
                          </ListItemIcon>
                          Delete File
                        </MenuItem>
                      </Menu>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <div className="table-pagination">
            <TablePagination
              rowsPerPageOptions={[10, 20, 25, 100]}
              component="div"
              rowsPerPage={props.limit}
              page={props.page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              count={props.totalCount}
            />
          </div>
          {/* {props.totalCount > 15 && (
                      <Stack m={2} spacing={2}>
                        <Pagination
                          page={page}
                          onChange={(_, page) => {
                            // Always need safety check for page !== null
                            if (page !== null) {
                              setPage(page);
                            }
                          }}
                          count={Math.ceil(props.totalCount / 15)}
                          color="primary"
                        />
                      </Stack>
                    )} */}
        </div>
      ) : (
        <TableLoader />
      )}
      <Modal open={opendelete} onClose={handleClosedelete} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Box className=" commonpopup  modal-common   popup-w35 ">
          <Link className="close" onClick={handleClosedelete}>
            X
          </Link>
          <div className="modal-body">
            <div className="popup_scroller">
              <div className="model-content text-center">
                <h3>Are you sure you want to delete?</h3>
              </div>
              <div className="modal-btn">
                <button className="btn btn-success btn-block  " onClick={handleClosedelete}>
                  Delete forever
                </button>
                <button className="btn btn-danger btn-block  " onClick={handleClosedelete}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
      <Modal open={openeditfile} onClose={handleCloseeditfile} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Box className=" commonpopup  modal-common   popup-w35 ">
          <div className="card-item__content    ">
            <div class="card-title">
              <h2>Rename File</h2>
              <span>Please provide a new name for {renameFile.newName}</span>
            </div>
            <Link className="close" onClick={handleCloseeditfile}>
              X
            </Link>
          </div>
          <div className="modal-body">
            <div className="popup_scroller">
              <div className="popup-knowledge">
                <div className="col-md-12">
                  <div className="form-group">
                    <label>File Name</label>
                    <FormControl fullWidth size="small">
                      <TextField id="outlined-multiline-flexible" value={renameFile.newName} onChange={handleNewNameChange} placeholder="Edit File Name" multiline />
                    </FormControl>
                  </div>
                  <div className="col-12 mt-3">
                    <div className="modal-btn">
                      <button type="button" className="btn btn-default w-50" onClick={handleCloseeditfile}>
                        Cancel
                      </button>
                      <button type="button" className="btn btn-primary w-50" onClick={() => handleRename(renameFile.id)}>
                        Confirm
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );
}
export default PdfList;
